import capitalize from "lodash/capitalize";
import { widgetDefinition } from "views/logic/Widgets";
const defaultTitleGenerator = ({ type }) => `Untitled ${type.replace("_", " ").split(" ").map(capitalize).join(" ")}`;
const defaultTitle = (widget) => {
  const widgetDef = widgetDefinition(widget.type);
  return (widgetDef.titleGenerator || defaultTitleGenerator)(widget);
};
export default defaultTitle;
